import { Pipe, PipeTransform } from '@angular/core';

import { BillingType } from '~core/models/invoice.models';

@Pipe({
  name: 'billingTypeLabel',
  standalone: true
})
export class BillingTypeLabelPipe implements PipeTransform {
  private readonly _typeMap: Record<BillingType, string> = {
    [BillingType.bToB]: 'Entreprise locale',
    [BillingType.bToC]: 'Particulier',
    [BillingType.bToF]: 'Entreprise internationale',
    [BillingType.bToG]: 'Gouvernement'
  };

  transform(type: BillingType | null | undefined): string {
    if (!type) return '';
    return this._typeMap[type];
  }
}
